


































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { resepStore } from "@/store/modules/resep";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import { isEmpty } from "lodash";
import moment from "moment";

import CardResepItems from "@/components/pemeriksaan/resep-obat/CardResepItems.vue";
import ResepObatSvc from "@/services/ResepObat";
import DialogResepInputItem from "@/components/modal/DialogResepInputItem.vue";
import { storeResepFarmasi } from "@/store/modules/resepfarmasi";
@Component({
  components: {
    CardResepItems,
    DialogResepInputItem
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class OrderResepList extends Vue {
  resepText = "";
  activeResep = {};
  expanded = [];
  expandedTerjadwal = [];
  removing = false;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  headers = [
    {
      text: "Tanggal",
      align: "start",
      value: "tanggal"
    },
    { text: "Nomor", value: "nomor" },
    { text: "Jenis", value: "jenis_resep" },
    { text: "Unit", value: "unit.nama" },
    { text: "Dokter", value: "dokter.nama" }
  ];

  get listResep() {
    return (
      resepStore.resep
        .filter(item => item.unit.id >= "50")
        // .filter(item => item.jenis_resep != 2)
        .sort(
          (a, b) =>
            new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
        )
        .sort(
          (a, b) =>
            new Date(b.tanggal).getTime() - new Date(a.tanggal).getTime()
        )
    );
  }

  get textResepTerjadwalToday() {
    return resepStore.anyResepTerjadwalToday
      .flatMap(item => item.items.map(sub => sub.obat_nama))
      .join("\r\n");
  }

  get loading() {
    return resepStore.listLoading;
  }

  get isEditable() {
    return !this.readOnly && userModule.user.profesi === "Dokter";
  }

  get canAddResep() {
    return !this.readOnly && userModule.user.profesi === "Dokter";
  }

  get register() {
    return this.$route.params.register;
  }

  @Watch("listResep", { deep: true })
  changedListResep() {
    this.resepText = "";
  }

  showResep(resep) {
    this.resepText = resep.text;
    this.activeResep = resep;
  }

  editResep(resep) {
    if (resep.order_emergensi_id) {
      this.$emit("open-order-emergensi", resep.order_emergensi_id);
      return;
    }
    if (userModule.isMedis) {
      if (resep.dokter.id == userModule.user.id && resep.status < 2) {
        this.$emit("edit-resep", resep);
      } else if (resep.dokter.id != userModule.user.id) {
        appModule.sendErrorAlert(
          "Tidak dapat mengedit resep yang ditulis dokter lain"
        );
      } else if (resep.status >= 2) {
        appModule.sendErrorAlert(
          "Tidak dapat mengedit resep karena sudah dilayani farmasi."
        );
      }
    }
  }

  get listResepTerjadwal() {
    return resepStore.resepTerjadwal;
  }

  get isAnyResepPulangByCurrentDokter() {
    return resepStore.anyResepPulang?.dokter.id == userModule.user.id;
  }

  addResep() {
    if (this.textResepTerjadwalToday) {
      const q = confirm(
        `Sudah ada resep terjadwal dibuat di hari ini: \r\n${this.textResepTerjadwalToday} \r\n\r\nTetap lanjutkan membuat Resep untuk hari ini?`
      );

      if (q) {
        this.$emit("add-resep");
        return true;
      } else {
        return false;
      }
    }

    if (this.isAnyResepPulangByCurrentDokter) {
      const q = confirm(
        `Sudah ada Resep Pulang untuk hari ini.\r\nTetap lanjutkan membuat Resep?`
      );

      if (q) {
        this.$emit("add-resep");
        return true;
      } else {
        return false;
      }
    }

    this.$emit("add-resep");
    return true;
  }

  formatDate(date) {
    // return new Intl.DateTimeFormat("id-ID", {
    //   month: "2-digit",
    //   day: "2-digit",
    //   year: "numeric",
    //   hour: "2-digit",
    //   minute: "2-digit",
    // }).format(new Date(date));

    moment(date).format("DD-MM-YYYY");
  }

  isEmpty(val) {
    return isEmpty(val);
  }

  getJenisResepName(item) {
    const jns = [
      {
        id: 1,
        name: ""
      },
      {
        id: 2,
        name: "Terjadwal"
      },
      {
        id: 3,
        name: "Cito"
      },
      {
        id: 4,
        name: "Pulang"
      }
    ];

    const jnsName = jns.find(val => val.id == item.jenis_resep);

    return jnsName?.name ?? "";
  }

  getListResep() {
    resepStore.getResepByRegister(this.register);
  }

  copyResep(item) {
    const q = confirm("Menyalin resep ini untuk dibuat order kembali?");

    if (q) {
      console.log("copy resep", item);
      const resep = { ...item };

      resep.id = null;
      resep.jenis_resep = 1;
      resep.tanggal = moment().format("YYYY-MM-DD");
      resep.status = 0;

      this.$emit("edit-resep", resep);
    }
  }

  async removeResep(item) {
    const q = confirm("Anda yakin menghapus resep ini?");

    if (q && !this.removing) {
      this.removing = true;

      await ResepObatSvc.remove(item.id)
        .then(resp => {
          if (resp.data.status == "1") {
            resepStore.getResepByRegister(this.register);

            appModule.sendSuccessNotice(resp.data.message);
            appModule.closeNoticeWithDelay();
          }
        })
        .finally(() => {
          this.removing = false;
        });

      this.$emit("remove-resep", item);
    }
  }

  parseIconName(status) {
    if (status <= 1) {
      return "mdi-send";
    } else {
      return "mdi-check-circle";
    }
  }

  parseIconColor(status) {
    if (status == 0) {
      return "";
      // } else if (status == 1) {
      //   return "warning";
    } else {
      return "success";
    }
  }

  parseStatusToText(item) {
    if (item.status == 0) {
      return "belum dikirim";
    }
    if (item.entry_farmasi && item.entry_farmasi.length) {
      return "sudah di-entry farmasi (No. Transaksi " + item.entry_farmasi.map(entry => entry.no_transaksi).join(", ") + ")";
    }
    if (item.status == 1) {
      return "terkirim, belum di-entry farmasi";
    }
    if (item.status == 2) {
      return "diproses farmasi, transaksi belum tercatat";
    }
    return "selesai disiapkan farmasi";
  }

  expandRow(item) {
    this.expanded.includes(item)
      ? (this.expanded = [])
      : (this.expanded = [item]);
  }

  expandRowTerjadwal(item) {
    this.expandedTerjadwal.includes(item)
      ? (this.expandedTerjadwal = [])
      : (this.expandedTerjadwal = [item]);
  }

  getCanEdit(item) {
    if (this.readOnly || item.order_emergensi_id) return false;
    return item.dokter.id == userModule.user.id;
  }

  getCanDelete(item) {
    if (this.readOnly || item.order_emergensi_id) return false;
    return item.dokter.id == userModule.user.id && item.status < 2;
  }

  showInputItem = false;

  editResepOnDialog(item) {
    this.activeResep = item;

    console.log("open resep dialog input", item);

    this.showInputItem = true;

    console.log("set showInputItem to true", this.showInputItem);
  }

  closeInputItem() {
    this.showInputItem = false;
    this.activeResep = null;
  }

  get activeResepItems() {
    // @ts-ignore temp
    return this.activeResep ? this.activeResep.items : null;
  }

  resepIdSending = null;

  quickSend(item) {
    if (item.order_emergensi_id) return;
    if (
      item.status == 0 &&
      item.jenis_resep != 2 &&
      item.tanggal <= moment().format("YYYY-MM-DD")
    ) {
      let q = null;
      if (item.dokter?.id != userModule.user.id) {
        q = confirm("Mengirim resep atas nama " + item.dokter?.nama + "??");
      } else {
        q = true;
      }

      if (q && this.resepIdSending !== item.id) {
        ResepObatSvc.sendResep(item.id)
          .then(resp => {
            this.resepIdSending = item.id;

            if (resp.data.status == 1) {
              appModule.sendSuccessNotice("Berhasil mengirim order");
              appModule.closeNoticeWithDelay();

              item.status = 1;
            }
          })
          .finally(() => {
            this.resepIdSending = null;
          });
      }
    }
  }
}
